import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    DialogContent,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Checkbox,
    ListItemText,
    FormControlLabel,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import { ValidDataService } from '../../../../service/validDataService';

export default function EditValidLabForm({ open, onClose, onRecordEdit, validLab }) {

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const response = await ValidDataService.updateValidLab({ ...values });
            const { code, data, message } = response;
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordEdit(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.log(error);
            }
            toast.error('Failed to update record');
        }
    };

    return (
        <DraggableDialog title={"Edit Lab"} onClose={onClose} open={open} width={'md'}>
            <DialogContent>
                <Formik
                    initialValues={{ 
                        id: validLab?.id || 0,
                        name: validLab?.name || '',
                        contactPerson: validLab?.contactPerson || '',
                        phone: validLab?.phone || '',
                        email: validLab?.email || '',
                        fax: validLab?.fax || '',
                        address: validLab?.address || '',
                        city: validLab?.city || '',
                        state: validLab?.state || '',
                        zip: validLab?.zip || '',
                        country: validLab?.country || '',
                        website: validLab?.website || '',
                        //specialties: validLab?.specialties || ['both'],
                        //turnaroundDays: validLab?.turnaroundDays || 7,
                        //rushAvailable: validLab?.rushAvailable || true,
                        //rushDays: validLab?.rushDays || 3,
                        status: validLab?.status || 'active',
                        //notes: validLab?.notes || ''
                    }}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, touched, isValid }) => (
                        <Form>
                            <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name='name'
                                        label="Lab Name"
                                        required
                                        fullWidth
                                        size="small"
                                    />
                                    <ErrorMessage name='name'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name={`contactPerson`}
                                        label="Contact Person"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`phone`}
                                        label="Phone"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`email`}
                                        label="Email"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`fax`}
                                        label="Fax"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name={`address`}
                                        label="Address"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        name={`city`}
                                        label="City"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`state`}
                                        label="State"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`zip`}
                                        label="Postal Code"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`country`}
                                        label="Country"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name={`website`}
                                        label="Website"
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                {/* <Grid item xs={12} md={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Specialties</InputLabel>
                                    <Field
                                        as={Select}
                                        name={`specialties`}
                                        label="Specialties"
                                        multiple
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        <MenuItem value="glasses">
                                            <Checkbox checked={form.values.validLabsData[index].specialties.includes('glasses')} />
                                            <ListItemText primary="Glasses" />
                                        </MenuItem>
                                        <MenuItem value="contacts">
                                            <Checkbox checked={form.values.validLabsData[index].specialties.includes('contacts')} />
                                            <ListItemText primary="Contacts" />
                                        </MenuItem>
                                        <MenuItem value="both">
                                            <Checkbox checked={form.values.validLabsData[index].specialties.includes('both')} />
                                            <ListItemText primary="Both" />
                                        </MenuItem>
                                    </Field>
                                </FormControl>
                            </Grid> */}
                                {/* <Grid item xs={12} md={1}>
                                <Field
                                    as={TextField}
                                    name={`validLabsData[${index}].turnaroundDays`}
                                    label="Days"
                                    type="number"
                                    fullWidth
                                    size="small"
                                />
                            </Grid> */}
                                {/* <Grid item xs={12} md={2}>
                                <FormControlLabel
                                    control={
                                        <Field
                                            as={Checkbox}
                                            name={`validLabsData[${index}].rushAvailable`}
                                            checked={form.values.validLabsData[index].rushAvailable}
                                        />
                                    }
                                    label="Rush Available"
                                />
                            </Grid> */}
                                <Grid item xs={12} md={2}>
                                    <Field
                                        as={TextField}
                                        name={`status`}
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value="active">Active</MenuItem>
                                        <MenuItem value="inactive">Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button sx={{ mr: 1 }} type="submit" variant="contained" color="primary" disabled={isSubmitting || !isValid}>
                                        {isSubmitting ? 'Saving...' : 'Update'}
                                    </Button>
                                    <Button variant="outlined" onClick={onClose}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog>
    );
};